import createDuck, {createAction, createThunk} from './../utils/actions';
import axios from '../net/axios';
import config from './../config';
let baseUrl = config.api.baseUrl;
const newActions = {
  test: name => createAction('NAME', name),
};

const newReducers = {
  ['NAME']: (state, action) => {
    const nState = {data: action.payload, loading: false, error: null};
    return {...state, ...nState};
  },
};

const duck = createDuck('TEST_LIST', newActions, newReducers);

const testListThunk = () => {
  const url = `${baseUrl}/api/users?page=2`;
  return createThunk(axios, 'get', duck.actions, url, null);
};



export default {
  duck,
  testListThunk,
};
